import { RestaurantStatus } from '@shared/types/restaurants';

export interface RestaurantOption {
  label: string;
  value: string;
}

export const buildRestaurantOptions = (
  restaurants: Array<{ name: string; id: string; status: RestaurantStatus }>,
): RestaurantOption[] => {
  return restaurants
    .map((restaurant) => ({
      label: restaurant.name,
      value: restaurant.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};
